// client/editor/presets/rich-text-editor.ts
import { DesignSystem } from "@adornis/chemistry/elements/theming/design.js";
import { bold } from "../../marks/bold.js";
import { color, colorMenuItem } from "../../marks/color.js";
import { createFontSizeMenuItem, fontSize } from "../../marks/font-size.js";
import { italic } from "../../marks/italic.js";
import { link } from "../../marks/link/linkConfig.js";
import { strikeThrough } from "../../marks/strike-through.js";
import { createTextAlignMenuItem } from "../../marks/text-align.js";
import { underline } from "../../marks/underline.js";
import { CollapsibleMenuItem } from "../../menu-items/CollapsibleMenuItem.js";
import { CopySelectionMenuItem, PasteFromClipboardMenuItem } from "../../menu-items/CopySelectionToClipboard.js";
import { hardBreak } from "../../nodes/hard-break.js";
import { heading } from "../../nodes/headings.js";
import { listConfig } from "../../nodes/list.js";
import { addLinkOnPastePlugin } from "../../plugins/addLinkOnPastePlugin.js";
import { arrowAutocompletion } from "../../plugins/arrowAutocompletion.js";
import { CurrentPathConfig } from "../../plugins/currentPathBarPlugin.js";
import { pasteHandler } from "../../plugins/pasteHandlerPlugin.js";
import { GermanQuotesConfig } from "../../plugins/quotePlugin.js";
import { plainEditorConfig } from "./plain-editor.js";
var richTextEditorConfig = (props) => [
  ...plainEditorConfig(),
  listConfig(),
  bold(),
  color(),
  fontSize(),
  italic(),
  link(),
  strikeThrough(),
  underline(),
  hardBreak(),
  heading(),
  {
    menuItems: [
      createTextAlignMenuItem("left"),
      createTextAlignMenuItem("center"),
      createTextAlignMenuItem("right"),
      createTextAlignMenuItem("justify")
    ]
  },
  {
    menuItems: [
      new CollapsibleMenuItem({
        label: "Schriftgr\xF6\xDFe",
        icon: "text_fields",
        menuItems: [
          createFontSizeMenuItem("8px"),
          createFontSizeMenuItem("12px"),
          createFontSizeMenuItem("16px"),
          createFontSizeMenuItem("20px"),
          ...props?.fontSizes?.map((fs) => createFontSizeMenuItem(fs)) ?? []
        ]
      })
    ]
  },
  {
    menuItems: [
      colorMenuItem(DesignSystem.currentTheme.getValue().colors.accent),
      colorMenuItem(DesignSystem.currentTheme.getValue().colors.primary),
      colorMenuItem(DesignSystem.currentTheme.getValue().colors.secondary),
      ...props?.colors?.map((c) => colorMenuItem(c)) ?? []
    ]
  },
  GermanQuotesConfig,
  CurrentPathConfig,
  {
    plugins: (schema) => {
      return [addLinkOnPastePlugin(schema)];
    }
  },
  {
    plugins: (schema) => {
      return [pasteHandler];
    }
  },
  {
    plugins: (schema) => {
      return [arrowAutocompletion];
    }
  },
  {
    menuItems: [CopySelectionMenuItem, PasteFromClipboardMenuItem]
  }
];
export {
  richTextEditorConfig
};
